<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>商品标签</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="fetchList">
            <el-table-column prop="tagId" label="ID">
            </el-table-column>
            <el-table-column prop="name" label="标签名称">
            </el-table-column>
            <el-table-column prop="description" label="描述">
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="创建时间">
               <span>{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="150" label="操作">
                <span>
                                            <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                                        	<!-- <el-button @click="handleDelete($index, row)" type="text" size="small">删除</el-button> -->
                                        </span>
            </el-table-column>
        </el-table>
    
        <el-dialog title="新建标签" v-model="addTag">
            <el-form :model="tagForm" ref="tagForm" :rules="addTagRules" label-width="120px">
                <el-form-item label="标签名称" label-width="120px" prop="name">
                    <el-input v-model="tagForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="标签描述" label-width="120px" prop="description">
                    <el-input v-model="tagForm.description" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addTag = false">取 消</el-button>
                    <el-button type="primary" @click="handleNewTag">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
        <el-dialog title="编辑标签" v-model="editTag">
            <el-form :model="tagForm" ref="tagForm" :rules="addTagRules" label-width="120px">
                <el-form-item label="标签名称" label-width="120px" prop="name">
                    <el-input v-model="tagForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="标签描述" label-width="120px" prop="description">
                    <el-input v-model="tagForm.description" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="editTag = false">取 消</el-button>
                    <el-button type="primary" @click="handleUpdateTag">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getProductTags,
        postProductTags,
        patchProductTags,
        deleteProductTags
    } from '../../api/version'
    
    export default {
        data() {
            return {
                fetchList: [],
                addTag: false,
                editTag: false,
                uptoken: {
                    token: sessionStorage.token
                },
                tagForm: {
                    name: '',
                    description: '',
                },
                addTagRules: {
                    name: [{
                        required: true,
                        message: '请输入标签名称',
                        trigger: 'blur'
                    }],
                    description: [{
                        required: true,
                        message: '请输入标签描述',
                        trigger: 'blur'
                    }]
                }
            }
        },
    
        created() {
            //获取商品标签
            getProductTags().then(res => {
                console.log(res.data)
                this.fetchList = res.data
            }, err => {
                console.log(err)
            })
        },
    
        methods: {
            //删除分类
            handleDelete(index, row) {
                //index 索引
                // row 当前数据
                this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fetchList.splice(index, 1)
    
                    deleteProductTags(row.tagId, sessionStorage.userId).then(res => {
                        if (res.data.count) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    }, err => {
                        this.$message.error('删除分类失败');
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //编辑分类
            handleEdit(index, row) {
                this.editTag = true
                this.tagForm = row
            },
            handleAdd() {
                //新建分类按钮
                this.tagForm = {
                    name: '',
                    description: ''
                }
                this.addTag = true
            },
            //编辑分类
            handleUpdateTag() {
                this.$refs['tagForm'].validate((valid) => {
                    let data = JSON.parse(JSON.stringify(this.tagForm))
                    delete data.tagId
                    patchProductTags(this.tagForm.tagId, sessionStorage.userId, data).then(res => {
                        //返回新增数据，插入表格中。
                        this.editTag = false
                        this.$message({
                            type: 'success',
                            message: '更新成功!'
                        });
                    }, err => {
                        this.$message.error('新增分类失败');
                    })
    
                })
            },
            handleNewTag() {
                //新建分类提交按钮
                this.$refs['tagForm'].validate((valid) => {
                    this.tagForm.isOnline = true
                    postProductTags(sessionStorage.userId, this.tagForm).then(res => {
                        //返回新增数据，插入表格中。
                        this.fetchList.push(res.data)
                        this.addTag = false
                        this.$message({
                            type: 'success',
                            message: '成功增加分类!'
                        });
                    }, err => {
                        this.$message.error('新增分类失败');
                    })
                })
            },
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// ProductTag.vue?7bff629f